// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3xzxS","containerItemsCenter":"Skeleton_containerItemsCenter__2Be1k"};